<template>
  <perfect-scrollbar class="container dictionary-ps">
    <div
      v-for="(item, index) in dictionary"
      :key="index"
      class="headword"
      :class="{ last: index == dictionary.length - 1 }"
    >
      <div class="vocab-text pronounciation-inflec">
        <el-row class="pronounciation">
          <el-col :span="6">
            <span class="pronounciation-label">{{ pronounciationLabel }}</span>
          </el-col>
          <el-col :span="18" class="ls-1">{{ item.pronunciation }}</el-col>
        </el-row>

        <el-row class="inflect">
          <el-col :span="6">
            <span class="inflect-label">{{ inflectionLabel }}</span>
          </el-col>
          <el-col :span="18" class="ls-1">{{ item.inflection.join(', ') }}</el-col>
        </el-row>
      </div>

      <div v-for="(meaning, key) in item.meaning" :key="key" class="meaning">
        {{ meaning }}
      </div>
    </div>
  </perfect-scrollbar>
</template>

<script>
export default {
  props: {
    dictionary: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      scroll: null
    };
  },
  mounted() {
    this.scroll = document.querySelector('.dictionary-ps');
    if (this.scroll) {
      this.scroll.addEventListener('touchmove', this.removeScrollPropagation, { passive: false });
    }
  },
  computed: {
    pronounciationLabel() {
      return this.$t('vocabulary.tooltip.pronounciation');
    },
    inflectionLabel() {
      return this.$t('vocabulary.tooltip.inflection');
    }
  },
  methods: {
    /**
     * Perfect scrollbar has an issue on nested scroll on mobile (html-materials > dictionary tooltip)
     * Scrolling child will also scroll the parent element
     */
    removeScrollPropagation(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  },
  beforeDestroy() {
    this.scroll.removeEventListener('touchmove', this.removeScrollPropagation);
  }
};
</script>
